import { BaseBus } from './BaseBus';

export class TimeEntryBus extends BaseBus
{
    constructor(data: TimeEntryBus = null) {
    super(data);
    if (data !== undefined && data !== null) {
        this.startTime = new Date(data.startTime);
        this.endTime = new Date(data.endTime);
    }
  }
    timeEntryId: any;
    personId: any;
    companyId: any;
    //payTypeId: any;
    //timeTypeId: any;
    startTime: Date;
    endTime: Date;
    hours: number;
    //dispatchId: any;
    //notes: string;
    //nonPaid: boolean = false;
    //timeOffRequestId: any;
    //mgrApproved: boolean = false;
    //mgrApprovedUserId: any;
    //mgrApprovedDt: Date;
    //insertUserId: any;
    //updateUserId: any;
  //public clockOut() {
  //  //this.hoursRequested = this.hours + this.mins / 60;
  //    if (this.endTime === undefined || this.endTime === null) {
  //        this.endTime = new Date(Date.now());
  //      }
  //  }
  //  public clockIn() {
  //      if (this.startTime === undefined || this.startTime === null) {
  //          this.startTime = new Date(Date.now());
  //      }
    //  }
    CID(): any {
        super.CID();
        return this.timeEntryId;
    }
}
